import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import LeerlingFlow from './pages/leerling/LeerlingFlow';
import LeerkrachtDashboard from './pages/leerkracht/LeerkrachtDashboard';
import BeheerPaneel from './pages/beheer/BeheerPaneel';

// Waar de API staat. Leeg betekent: op hetzelfde domein als deze pagina.
// Zo is de opstelling ook bedoeld -- Caddy (of wat Boom IT daarvoor
// gebruikt) stuurt /auth, /admin, /student en /health naar de backend en de
// rest naar de frontend -- en dan hoeft er bij een verhuizing naar een ander
// domein niets aan de code te veranderen. Staat de API ergens anders, zet
// dan REACT_APP_API_URL bij het bouwen. Bij `npm start` stuurt de
// proxy-regel in package.json de aanroepen naar de backend op poort 8000.
const API_URL = process.env.REACT_APP_API_URL || '';

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData, tokenData) => {
    setUser(userData);
    setToken(tokenData);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', tokenData);
  };

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  if (!user) {
    return <Login onLogin={handleLogin} apiUrl={API_URL} />;
  }
  
  if (user.role === 'admin') {
    return <BeheerPaneel user={user} token={token} onLogout={handleLogout} apiUrl={API_URL} />;
  }

  if (user.role === 'teacher') {
    return <LeerkrachtDashboard user={user} token={token} onLogout={handleLogout} apiUrl={API_URL} />;
  }

  return <LeerlingFlow user={user} token={token} onLogout={handleLogout} apiUrl={API_URL} />;
}

export default App;
